import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';
import { Title } from './Title';

interface PageHeaderProps {
    id?: string;
    title: string;
    subtitle?: string | React.ReactNode;
    actions?: React.ReactNode;
}

export function PageHeader({ id, title, subtitle, actions }: PageHeaderProps) {
    return (
        <Header>
            <div id={id}>
                <Title size="h1">{title}</Title>
                {subtitle && typeof subtitle === 'string' ? <Subtitle>{subtitle}</Subtitle> : subtitle}
            </div>
            {actions && <Actions>{actions}</Actions>}
        </Header>
    );
}

const Header = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 24,
});

const Subtitle = styled('p')({
    fontSize: 15,
    color: Colors.mediumGrey,
    margin: '4px 0 0',
});

const Actions = styled('div')({
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    gap: 12,
});
